var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBulb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.14286 14.5C4.41735 13.3082 4 11.9118 4 10.4189C4 6.04539 7.58172 2.5 12 2.5C16.4183 2.5 20 6.04539 20 10.4189C20 11.9118 19.5827 13.3082 18.8571 14.5",
    stroke: "#909090",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.38287 17.5982C7.291 17.3216 7.24507 17.1833 7.25042 17.0713C7.26174 16.8343 7.41114 16.6262 7.63157 16.5405C7.73579 16.5 7.88105 16.5 8.17157 16.5H15.8284C16.119 16.5 16.2642 16.5 16.3684 16.5405C16.5889 16.6262 16.7383 16.8343 16.7496 17.0713C16.7549 17.1833 16.709 17.3216 16.6171 17.5982C16.4473 18.1094 16.3624 18.3651 16.2315 18.572C15.9572 19.0056 15.5272 19.3167 15.0306 19.4408C14.7935 19.5 14.525 19.5 13.9881 19.5H10.0119C9.47495 19.5 9.2065 19.5 8.96944 19.4408C8.47283 19.3167 8.04281 19.0056 7.7685 18.572C7.63755 18.3651 7.55266 18.1094 7.38287 17.5982Z",
    stroke: "#909090",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 19.5L14.8707 20.1466C14.7293 20.8537 14.6586 21.2072 14.5001 21.4866C14.2552 21.9185 13.8582 22.2439 13.3866 22.3994C13.0816 22.5 12.7211 22.5 12 22.5C11.2789 22.5 10.9184 22.5 10.6134 22.3994C10.1418 22.2439 9.74484 21.9185 9.49987 21.4866C9.34144 21.2072 9.27073 20.8537 9.12932 20.1466L9 19.5",
    stroke: "#909090",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5521 7L11.0305 8.69458C10.8214 8.92743 10.9486 9.29939 11.2566 9.35537L12.7453 9.62605C13.0732 9.68567 13.1886 10.0966 12.9398 10.3183L11.0521 12",
    stroke: "#909090",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulb);
export default __webpack_public_path__ + "static/media/bulb.9c6bede230f72cc08ef5835490990eef.svg";
export { ForwardRef as ReactComponent };